import { SafetyOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Flex, Image, Row, Table } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Text from 'antd/es/typography/Text';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { getImageUrl } from '../../../utils';
import { ReactComponent as AddGameIcon } from '../assets/addGame.svg';
import { ReactComponent as ChanelIcon } from '../assets/chanel.svg';
import { ReactComponent as PlayIcon } from '../assets/play.svg';
import { ChoiceGroup, ResultChoice } from '../components';
import { ChoiceTypeEnum, GameStatusEnum, IGameItem } from '../store/game.types';
import { CreateGamePanel } from './CreateGamePanel';

class _GamesTableMobile extends Component<IRootStoreProps> {
  static contextType = AppContext;
  render() {
    const { globalTheme } = this.context as AppContextValue;
    const {
      listGames,
      updateChoiceGame,
      update,
      total,
      getGamesParams,
      newGame,
      handleTableChange,
      isGameModal,
      isCreateGameModal,
      showGameModal,
      showCreateGameModal,
      closeCreateGameModal,
      closeGameModal,
      selectedGame,
    } = this.props.store.game;
    const pagination = { total: total, pageSize: getGamesParams.limit };
    const columns = [
      {
        dataIndex: 'betAmount',
        key: 'betAmount',
        sorter: true,
        render: (amount: number, item: IGameItem, index: number) => {
          const valueChoice = item?.isOwner ? item?.ownerChoice : item.selectedChoice;
          const isDisabled = item.status !== GameStatusEnum.CREATED;
          const isCanceled = item.status === GameStatusEnum.CANCELED;
          const betColor = isCanceled
            ? globalTheme?.colorBorder
            : index % 2 === 0
              ? globalTheme?.blue6
              : globalTheme?.red5;

          const isFinished = item.status === GameStatusEnum.FINISHED;

          return (
            <Row style={{ borderRadius: 8, marginBottom: 8, marginInline: 8, backgroundColor: '#F7F7F7' }}>
              <Col
                span={6}
                style={{
                  borderTopLeftRadius: 8,
                  borderBottomLeftRadius: 8,
                  backgroundColor: '#F2F2F2',
                  padding: 7,
                }}
              >
                <Flex vertical justify={'center'} align={'center'}>
                  <Text style={{ fontWeight: 600, fontSize: 12 }}>СТАВКА</Text>
                  <Text style={{ fontWeight: 600, fontSize: 20, color: item.colorResult || betColor, marginTop: 10 }}>
                    {item.betAmount}
                  </Text>
                </Flex>
              </Col>
              <Col span={18}>
                <Row style={{ padding: 5 }}>
                  {isFinished ? (
                    <>
                      <Text style={{ fontWeight: 400, fontSize: 14, marginLeft: 10 }}>{item.ownerName}</Text>
                      <Text
                        style={{
                          fontWeight: 400,
                          fontSize: 24,
                          marginLeft: 10,
                          rotate: '45deg',
                          lineHeight: 0.8,
                          color: globalTheme?.colorBorder,
                        }}
                      >
                        {'+'}
                      </Text>
                      <Text style={{ fontWeight: 400, fontSize: 14, marginLeft: 10 }}>{item.playerName}</Text>
                    </>
                  ) : (
                    <Flex justify={'space-between'} style={{ width: '100%' }}>
                      <Col>
                        <Image src={getImageUrl(item.ownerId)} width={20} />
                        <Text style={{ fontWeight: 400, fontSize: 14, marginLeft: 10 }}>{item.ownerName}</Text>
                      </Col>

                      <Button
                        type={'text'}
                        style={{
                          height: 25,
                          width: 20,
                          color: globalTheme?.green5,
                        }}
                        icon={<SafetyOutlined />}
                        onClick={() => showGameModal(item)}
                      >
                        {/* {'i'} */}
                      </Button>
                    </Flex>
                  )}
                </Row>
                {isFinished ? (
                  <Row style={{ display: 'flex', justifyContent: 'space-between', paddingInline: 7 }}>
                    <ResultChoice style={{ height: 36 }} game={item} clickInfo={() => showGameModal(item)} />
                  </Row>
                ) : (
                  <Row style={{ display: 'flex', justifyContent: 'space-between', paddingInline: 7 }}>
                    <ChoiceGroup
                      value={valueChoice}
                      onChange={(id?: ChoiceTypeEnum) => updateChoiceGame(item.gameId, id)}
                      style={{ height: 36 }}
                      disabled={item.isOwner}
                      type={newGame.type}
                      isOdd={!!(index % 2)}
                    />
                    <Button
                      style={{ height: 40, width: 48, borderRadius: 11, borderWidth: 0, backgroundColor: betColor }}
                      onClick={() => update(item?.gameId)}
                      disabled={isDisabled}
                      icon={item.isOwner ? <ChanelIcon /> : <PlayIcon style={{}} />}
                    />
                  </Row>
                )}
              </Col>
            </Row>
          );
        },
      },
    ];

    const handleCopy = () => {
      if (selectedGame?.md5) {
        navigator.clipboard
          .writeText(selectedGame.md5)
          .then(() => {
            this.props.store.notifications.success('Скопировано в буфер обмена!');
          })
          .catch(err => {
            this.props.store.notifications.error('Не удалось скопировать.');
          });
      }
    };

    return (
      <>
        <Table
          showHeader={false}
          dataSource={listGames.map((game: any) => ({ ...game, key: game.gameId }))}
          columns={columns}
          pagination={pagination}
          onChange={handleTableChange}
          style={{ background: 'transparent' }}
          rowClassName={() => 'custom-row'}
        />
        <Drawer
          height={200}
          style={{ borderTopRightRadius: 8, borderTopLeftRadius: 8 }}
          closable={false}
          title={
            <Flex justify={'space-between'}>
              <Row>
                <Image src={getImageUrl(selectedGame?.ownerId)} width={20} />
                <Text style={{ fontWeight: 600, fontSize: 16, marginLeft: 10 }}>{selectedGame?.ownerName}</Text>
              </Row>
              <Text>{selectedGame?.createdAt ? dayjs(selectedGame?.createdAt).format('HH:mm:ss') : ''}</Text>
            </Flex>
          }
          placement="bottom"
          onClose={closeGameModal}
          open={isGameModal}
        >
          <>
            <SafetyOutlined />
            <Text style={{ marginLeft: 10 }}>{'Hash для проверки честности игры'}</Text>
            <TextArea value={selectedGame?.md5} readOnly onClick={handleCopy} style={{ marginTop: 5 }} />
          </>
        </Drawer>
        <Drawer
          height={300}
          style={{ borderTopRightRadius: 8, borderTopLeftRadius: 8 }}
          closable={false}
          title={<Text>{'Создать новую игру'}</Text>}
          placement="bottom"
          onClose={closeCreateGameModal}
          open={isCreateGameModal}
        >
          <CreateGamePanel />
        </Drawer>
        {!isCreateGameModal && (
          <Button
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              zIndex: 9999,
              backgroundColor: '#E55A53',
              borderRadius: 25,
              width: 50,
              height: 50,
              borderWidth: 0,
              color: '#fff',
              fontSize: 30,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
            onClick={showCreateGameModal}
            icon={<AddGameIcon style={{ width: 50, height: 50 }} />}
          />
        )}
      </>
    );
  }
}

export const GamesTableMobile: WithoutStore = withStore(observer(_GamesTableMobile));
